var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame892(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3537 19.3535C24.4448 19.2592 24.4952 19.1329 24.494 19.0018C24.4929 18.8707 24.4403 18.7453 24.3476 18.6526C24.2549 18.5598 24.1295 18.5073 23.9984 18.5061C23.8673 18.505 23.741 18.5554 23.6467 18.6465L20.0002 22.293L18.3537 20.6465C18.2594 20.5554 18.1331 20.505 18.002 20.5061C17.8709 20.5073 17.7455 20.5598 17.6528 20.6526C17.5601 20.7453 17.5075 20.8707 17.5064 21.0018C17.5052 21.1329 17.5556 21.2592 17.6467 21.3535L20.0002 23.707L24.3537 19.3535Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 15.5V26C27 26.3978 26.842 26.7794 26.5607 27.0607C26.2794 27.342 25.8978 27.5 25.5 27.5H16.5C16.1022 27.5 15.7206 27.342 15.4393 27.0607C15.158 26.7794 15 26.3978 15 26V12C15 11.6022 15.158 11.2206 15.4393 10.9393C15.7206 10.658 16.1022 10.5 16.5 10.5H22L27 15.5ZM22 16C21.8674 16 21.7402 15.9473 21.6464 15.8536C21.5527 15.7598 21.5 15.6326 21.5 15.5V11.5H16.5C16.3674 11.5 16.2402 11.5527 16.1464 11.6464C16.0527 11.7402 16 11.8674 16 12V26C16 26.1326 16.0527 26.2598 16.1464 26.3536C16.2402 26.4473 16.3674 26.5 16.5 26.5H25.5C25.6326 26.5 25.7598 26.4473 25.8536 26.3536C25.9473 26.2598 26 26.1326 26 26V16H22ZM22.5 12.414L25.086 15H22.5V12.414Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13.5V27C14 27.3978 14.158 27.7794 14.4393 28.0607C14.7206 28.342 15.1022 28.5 15.5 28.5H25V29.5H15.5C14.837 29.5 14.2011 29.2366 13.7322 28.7678C13.2634 28.2989 13 27.663 13 27V13.5H14Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame892);
export default __webpack_public_path__ + "static/media/Frame 89 (2).b611cc6ad19e422cb8c684315fa8d510.svg";
export { ForwardRef as ReactComponent };